import styled, {css} from 'styled-components'

export const StyledFilterChips = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-wrap: wrap;
        gap: ${spacing * 1.5}px;
        padding-bottom: ${spacing * 3}px;
    `
)

export const StyledFilterChip = styled.button<{$active: boolean}>(
    ({theme: {palette, typography, spacing}, $active}) => css`
        ${typography.textSm};
        font-weight: 500;
        cursor: pointer;
        padding: ${spacing}px ${spacing * 2.5}px;
        border-radius: 999px;
        border: 1px solid ${$active ? palette.primary[600] : palette.neutral[200]};
        background-color: ${$active ? palette.primary[50] : palette.neutral.white};
        color: ${$active ? palette.primary[700] : palette.neutral[700]};
        transition:
            background-color 0.15s ease,
            border-color 0.15s ease,
            color 0.15s ease;

        &:hover {
            background-color: ${$active ? palette.primary[100] : palette.neutral[50]};
        }
    `
)

export const StyledLogsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    /* Fixed height — the Table renders limit-driven skeleton rows during loading,
       which would otherwise expand the modal and snap it back when real data lands.
       The inner table provides its own vertical scroll if rows exceed this box. */
    height: 420px;
    overflow: hidden;
`

export const StyledRecipientCell = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 0.5}px;
        min-width: 0;

        & .email {
            font-weight: 500;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
    `
)

export const StyledErrorCell = styled.span(
    ({theme: {palette}}) => css`
        color: ${palette.danger[600]};
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: inline-block;
        max-width: 240px;
    `
)
